var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.60879 0.608774C-0.20293 1.42049 -0.20293 2.73652 0.60879 3.54824L8.06053 10.9999L0.60879 18.4518C-0.20293 19.2635 -0.20293 20.5796 0.60879 21.3912C1.42049 22.2029 2.73654 22.2029 3.54824 21.3912L11 13.9394L18.4518 21.3912C19.2635 22.2029 20.5796 22.2029 21.3913 21.3912C22.2029 20.5796 22.2029 19.2635 21.3913 18.4518L13.9394 10.9999L21.3913 3.54826C22.2029 2.73656 22.2029 1.42052 21.3913 0.608816C20.5794 -0.202904 19.2635 -0.202904 18.4518 0.608816L11 8.06052L3.54824 0.608774C2.73654 -0.202925 1.42049 -0.202925 0.60879 0.608774Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.f2fb65c2421f17724af5c16ee382962d.svg";
export { ForwardRef as ReactComponent };